import * as React from 'react'
import { Toaster as Sonner } from 'sonner'
import { useTheme } from '@/hooks/use-theme'

type ToasterProps = React.ComponentProps<typeof Sonner>

function Toaster({ ...props }: ToasterProps) {
  const { resolvedTheme } = useTheme()

  return (
    <Sonner
      theme={resolvedTheme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          // !p-4/!gap-2 (important): Sonner's own CSS sets padding/gap via attribute selectors
          // ([data-sonner-toast][data-styled='true']), which otherwise wins over a same-specificity
          // Tailwind utility class regardless of stylesheet order.
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:!gap-2 group-[.toaster]:!p-4',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          // Sonner's default icon has its own -3px/+4px start/end margins on top of the toast's
          // flex gap, so the visible icon-to-text spacing is wider than the gap alone would
          // suggest — zero them out so gap-2 above is the only spacing in effect. The [data-icon]
          // wrapper is also hardcoded to 16x16px, smaller than our 20px (h-5 w-5) icons, so the svg
          // overflows the wrapper and eats into the flex gap — size the wrapper to match so gap-2
          // is the true visible spacing.
          icon: 'group-[.toast]:!mx-0 group-[.toast]:!h-5 group-[.toast]:!w-5',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
